<template>
	<section v-if="data && data.gallery" class="container margin-auto margin-both-lg">
		<div class="inner">
			<OwlCarousel :options="options" @carouselMounted="carouselMounted">
				<a
					class="inner-gallery"
					:data-fslightbox="'lightbox_' + shortId"
					:href="image.url"
					v-for="image in data.gallery"
					:key="image.id"
				>
					<svg
						class="open-lightbox"
						version="1.1"
						xmlns="http://www.w3.org/2000/svg"
						xmlns:xlink="http://www.w3.org/1999/xlink"
						x="0px"
						y="0px"
						viewBox="0 0 60 60"
						style="enable-background: new 0 0 60 60"
						xml:space="preserve"
					>
						<path
							d="M59.923,0.618c-0.101-0.245-0.296-0.44-0.541-0.541C59.26,0.027,59.13,0,59,0H39c-0.553,0-1,0.448-1,1s0.447,1,1,1h17.586
                    L34.293,24.293c-0.391,0.391-0.391,1.023,0,1.414C34.488,25.902,34.744,26,35,26s0.512-0.098,0.707-0.293L58,3.414V21
                    c0,0.552,0.447,1,1,1s1-0.448,1-1V1C60,0.87,59.974,0.74,59.923,0.618z"
						/>
						<path
							d="M24.293,34.293L2,56.586V39c0-0.552-0.447-1-1-1s-1,0.448-1,1v20c0,0.13,0.027,0.26,0.077,0.382
                    c0.101,0.245,0.296,0.44,0.541,0.541C0.74,59.973,0.87,60,1,60h20c0.553,0,1-0.448,1-1s-0.447-1-1-1H3.414l22.293-22.293
                    c0.391-0.391,0.391-1.023,0-1.414S24.684,33.902,24.293,34.293z"
						/>
					</svg>
					<WpImage :image="image" size="large" class="item" background cover styled-caption caption />
				</a>
			</OwlCarousel>
		</div>
	</section>
</template>

<script>
require('fslightbox')
import shortid from 'shortid'
import WpImage from '@/components/elements/WpImage'
const OwlCarousel = () => import('@/components/elements/OwlCarousel')
import { arrow } from '@/components/../icons'

export default {
	name: 'gallery',
	props: ['data'],
	components: {
		WpImage,
		OwlCarousel,
	},
	data() {
		return {
			shortId: shortid.generate(),
			options: {
				margin: 20,
				items: 1,
				autoHeight: true,
				loop: false,
				toggler: false,
				center: true,
				nav: true,
				navText: [arrow('var(--dark)'), arrow('var(--dark)')],
			},
		}
	},
	methods: {
		carouselMounted(e) {
			refreshFsLightbox()
		},
	},
	mounted() {},
}
</script>

<style lang="scss">
@import '@/assets/vars.scss';
@import '@/assets/mixins.scss';
.module-gallery {
	.inner-gallery {
		position: relative;
		display: block;
		text-decoration: none;
		&:focus {
			outline: none;
		}
		.open-lightbox {
			position: absolute;
			top: 25px;
			right: 25px;
			width: 30px;
			height: 30px;
			z-index: 10;
			path {
				fill: var(--light);
				stroke-width: 3px;
				stroke: var(--light);
			}
			@include mquery($phone) {
				top: 15px;
				right: 15px;
				width: 20px;
				height: 20px;
			}
		}
	}
	.wp-image-vue .image {
		background-color: var(--dark);
	}
	.wp-image-vue {
	}
	.owl-dots {
		display: none;
	}
	.owl-carousel {
		position: relative;

		.owl-prev {
			left: -25px;
			svg {
				transform: rotate(-180deg);
			}
		}
		.owl-next {
			right: -25px;
		}
		.owl-prev,
		.owl-next {
			position: absolute;
			top: 50%;
			z-index: 20;
			transform: translateY(-50%);
			background: transparent;
			border: none;
			box-shadow: none;
			cursor: pointer;

			svg {
				height: 12px;
				width: 17px;
				path {
					transition: 0.2s fill ease-in-out;
					will-change: stroke;
				}
			}
			&.disabled {
				opacity: 0.5;
				cursor: default;
				pointer-events: none;
			}
			&:hover {
				svg {
					path {
						fill: $red;
					}
				}
			}
		}
		@include mquery($container) {
			.owl-prev {
				left: 20px;
				svg {
					margin-right: 3px;
				}
				&:after {
					left: 0px;
				}
			}
			.owl-next {
				right: 20px;
				svg {
					margin-right: -2px;
				}
				&:after {
					left: 2px;
				}
			}
			.owl-prev,
			.owl-next {
				//background: #fff !important;
				width: 32px;
				height: 100px;
				@include mquery($phone) {
					height: 50px;
				}
				svg {
					position: relative;
					height: 18px;
					width: 22px;
					margin-top: 3px;
					z-index: 3;
				}
				&:after {
					z-index: 2;
					content: '';
					background: var(--light);
					width: 29px;
					height: 29px;
					top: 35px;
					position: absolute;
					@include mquery($phone) {
						top: 10px;
					}
				}
			}
		}
	}
}
</style>
